"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalBarChart = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const recharts_1 = require("recharts");
const styled_components_1 = require("styled-components");
const HorizontalBarChart = ({ chartData, barDataKey, yAxisDataKey }) => {
    const theme = (0, styled_components_1.useTheme)();
    const maxTickValueLengthAllowed = 10;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: chartData && ((0, jsx_runtime_1.jsx)(recharts_1.ResponsiveContainer, { children: (0, jsx_runtime_1.jsxs)(recharts_1.BarChart, { data: chartData, layout: "horizontal", margin: {
                    left: 0,
                    right: 0,
                }, children: [(0, jsx_runtime_1.jsx)(recharts_1.XAxis, { axisLine: false, type: "category", dataKey: yAxisDataKey, tickLine: false, tickFormatter: value => `${value.substring(0, maxTickValueLengthAllowed)}...` }), (0, jsx_runtime_1.jsx)(recharts_1.YAxis, { hide: true, type: "number", domain: [
                            'dataMin',
                            (dataMax) => {
                                if (dataMax <= 10) {
                                    return dataMax + 1;
                                }
                                return Math.round(dataMax * 1.2);
                            },
                        ], tickLine: false, allowDecimals: false }), (0, jsx_runtime_1.jsx)(recharts_1.CartesianGrid, { horizontal: true, vertical: false }), (0, jsx_runtime_1.jsx)(recharts_1.Tooltip, {}), (0, jsx_runtime_1.jsx)(recharts_1.Bar, { dataKey: barDataKey, fill: theme.color.brand1, maxBarSize: 12, radius: [12, 12, 0, 0], minPointSize: 4 })] }) })) }));
};
exports.HorizontalBarChart = HorizontalBarChart;
